import React from 'react';
import { Link, FormattedMessage } from 'gatsby-plugin-intl';

import AnimateLink from '../../animateLink';

const NavContact = ({ navLinks, cssClass }) => {
  return (
    <ul className={` ${cssClass ? cssClass : ''}`}>
      <li>
        <AnimateLink
          externalLink={true}
          url="https://www.linkedin.com/company/publicis-conseil/jobs/?viewAsMember=true"
          cssClassLink="link-menu-ext"
        >
          <FormattedMessage id="footer.job_offers" />{' '}
          <span className="icon-icon-menu"></span>
        </AnimateLink>
      </li>
      <li>
        <AnimateLink
          externalLink={true}
          url="https://www.jobteaser.com/fr/companies/publicis-groupe"
          cssClassLink="link-menu-ext"
        >
          <FormattedMessage id="footer.internship_offers" />{' '}
          <span className="icon-icon-menu"></span>
        </AnimateLink>
      </li>
      {navLinks[0]?.colContact?.map(({ seo }, i) => {
        return (
          <li key={i}>
            <Link to={`/${seo.slug}`}>{seo.title}</Link>
          </li>
        );
      })}
      <li>
        <a href="mailto:newbiz@conseil.publicis.fr">Newbiz</a>
      </li>
      <li>
        <a href="mailto:presse@conseil.publicis.fr">
          <FormattedMessage id="footer.press" />
        </a>
      </li>
    </ul>
  );
};

export default NavContact;
